import { DocumentErrorEvent, DocumentManagerPlugin } from '@embedpdf/plugin-document-manager';
import { UIPlugin } from '@embedpdf/plugin-ui';
import { PDFViewer, PDFViewerRef, ZoomMode } from '@embedpdf/react-pdf-viewer';
import { Stack, useTheme } from '@mui/material';
import { MprcMessageBox } from 'components/MprcMessageBox';
import { useEffect, useRef, useState } from 'react';

interface IProps {
    url: string;
    locale: string;
}

export const MprcPdfViewer = ({ url, locale }: IProps) => {
    const [error, setError] = useState<DocumentErrorEvent | null>(null);
    const theme = useTheme();
    const l = locale.length == 5 && locale != "pt-BR" ? locale.substring(0, 2) : locale;
    const viewerRef = useRef<PDFViewerRef>(null);

    async function onReady() {
        const registry = await viewerRef.current?.registry;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const ui = registry?.getPlugin<UIPlugin>('ui')?.provides();
        // Habilitar para obter todas as possível categorias do PdfViewer
        // console.log(JSON.stringify(ui?.getSchema(), null, 2));
    }

    useEffect(() => {
        async function init() {
            const registry = await viewerRef.current!.registry;
            if (registry) {
                const docManager = registry.getPlugin<DocumentManagerPlugin>('document-manager')?.provides();
                if (docManager) {
                    docManager.onDocumentError((e) => {
                        if (e.code != 4) setError(e);
                    });
                }
            }
        }

        if (viewerRef.current) init();

    }, [viewerRef]);

    return (
        error
            ? <Stack justifyContent="center" alignItems="center" sx={{ height: "100%", margin: 4 }}>
                <MprcMessageBox
                    fullWidth
                    variant='error'
                    message={
                        <>
                            <b>{error.message}</b>
                            {error.reason && <p><small>{error.reason.message}</small></p>}
                        </>
                    }
                />
            </Stack>
            : <PDFViewer
                ref={viewerRef}
                onReady={onReady}
                config={{
                    src: url,
                    theme: {
                        preference: 'light',
                        light: {
                            background: {
                                app: theme.palette.paper.main,         // The main background behind the document
                                surface: theme.palette.paper.dark,     // Toolbars, sidebars, panels
                            },
                        },
                    },
                    disabledCategories: [
                        //'annotation',
                        'annotation-markup',
                        'annotation-ink',
                        'annotation-text',
                        'annotation-stamp',
                        'annotation-shape',
                        'annotation-rectangle',
                        'annotation-circle',
                        'annotation-line',
                        'annotation-arrow',
                        'annotation-polygon',
                        'annotation-polyline',
                        'annotation-delete',
                        'annotation-comment',
                        'annotation-style',
                        'stamp',
                        'mode-annotate',
                        'mode-shapes',
                        'document-export',
                        'document-open',
                        'document-close',
                        'document-capture',
                        'document-protect',
                        'form',
                        'insert',
                        'insert-rubber-stamp',
                        'panel-sidebar',
                        'panel-comment',
                        'redaction',
                        'tools'
                    ],
                    zoom: {
                        defaultZoomLevel: ZoomMode.FitWidth
                    },
                    pan: {
                        defaultMode: 'always'
                    },
                    i18n: {
                        defaultLocale: l,
                        fallbackLocale: 'pt-BR'
                    }
                }}
                style={{ width: '100%', height: '100%' }}
            />
    );
};